import { FC } from 'react';
import { Link, useLocation } from 'react-router-dom';
import clsx from 'clsx';
import { propertyService } from '@services/property.service';
import { useState, useEffect } from 'react';

interface BottomNavProps {
  onMenuOpen?: () => void;
}

export const BottomNav: FC<BottomNavProps> = () => {
  const location = useLocation();
  const [counts, setCounts] = useState<Record<string, number>>({});

  useEffect(() => {
    propertyService.getCounts().then(setCounts).catch(() => {});
  }, [location.pathname]);

  const isActive = (path: string) => location.pathname === path;

  const mainItems = [
    {
      path: '/dashboard',
      label: 'Accueil',
      icon: (
        <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2}
            d="M3 12l2-2m0 0l7-7 7 7M5 10v10a1 1 0 001 1h3m10-11l2 2m-2-2v10a1 1 0 01-1 1h-3m-6 0a1 1 0 001-1v-4a1 1 0 011-1h2a1 1 0 011 1v4a1 1 0 001 1m-6 0h6" />
        </svg>
      ),
    },
    {
      path: '/listings',
      label: 'Annonces',
      badge: Object.values(counts).reduce((s, n) => s + n, 0) || null,
      icon: (
        <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2}
            d="M4 6h16M4 10h16M4 14h16M4 18h16" />
        </svg>
      ),
    },
    {
      path: '/first-selection',
      label: '1ère sél.',
      badge: counts['FIRST_SELECTION'] || null,
      icon: (
        <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2}
            d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
        </svg>
      ),
    },
    {
      path: '/opportunities',
      label: 'Opportunités',
      badge: counts['OPPORTUNITY'] || null,
      icon: (
        <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2}
            d="M11.049 2.927c.3-.921 1.603-.921 1.902 0l1.519 4.674a1 1 0 00.95.69h4.915c.969 0 1.371 1.24.588 1.81l-3.976 2.888a1 1 0 00-.363 1.118l1.518 4.674c.3.922-.755 1.688-1.538 1.118l-3.976-2.888a1 1 0 00-1.176 0l-3.976 2.888c-.783.57-1.838-.197-1.538-1.118l1.518-4.674a1 1 0 00-.363-1.118l-3.976-2.888c-.784-.57-.38-1.81.588-1.81h4.914a1 1 0 00.951-.69l1.519-4.674z" />
        </svg>
      ),
    },
    {
      path: '/portfolio',
      label: 'Portefeuille',
      icon: (
        <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2}
            d="M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 01-2 2h-2a2 2 0 01-2-2z" />
        </svg>
      ),
    },
  ] as const;

  return (
    <nav className="lg:hidden fixed bottom-0 inset-x-0 z-40 bg-white dark:bg-gray-900 border-t border-gray-200 dark:border-gray-700 flex items-center safe-area-bottom">
      {mainItems.map((item) => (
        <Link
          key={item.path}
          to={item.path}
          className={clsx(
            'relative flex-1 flex flex-col items-center justify-center py-2 min-h-[56px] transition-colors',
            isActive(item.path)
              ? 'text-primary-600 dark:text-primary-400'
              : 'text-gray-500 dark:text-gray-400 hover:text-gray-700 dark:hover:text-gray-200'
          )}
          aria-label={item.label}
        >
          <span className="relative">
            {item.icon}
            {'badge' in item && item.badge != null && item.badge > 0 && (
              <span className="absolute -top-1.5 -right-2 min-w-[16px] h-4 px-1 rounded-full bg-accent-500 text-white text-[10px] font-bold flex items-center justify-center leading-none">
                {item.badge > 99 ? '99+' : item.badge}
              </span>
            )}
          </span>
          <span className="text-[10px] mt-0.5 font-medium leading-none">{item.label}</span>
          {isActive(item.path) && (
            <span className="absolute top-0 inset-x-0 h-0.5 bg-primary-600 dark:bg-primary-400 rounded-b" />
          )}
        </Link>
      ))}

    </nav>
  );
};
